import type { SigningStatus } from "@/shared/types";

/**
 * A registered but unsigned document is still a draft to the user: eGov holds a
 * SIGEX registration (status 0) that nobody has signed, and the domain status
 * only moves on the first real signature.
 */
export function isDraftSigningStatus(signingStatus: SigningStatus | null): boolean {
  return signingStatus === null || signingStatus === 0;
}
